var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 419,
    viewBox: "0 0 414 419",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_219_50842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.468 193.872L225.083 178.178",
    stroke: "black",
    strokeWidth: 1.92852,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.913 193.817L212.015 172.588",
    stroke: "black",
    strokeWidth: 1.92852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.867 208.789L163.391 173.576C165.828 169.182 165.8 163.836 163.317 159.467L141.794 121.594C139.015 116.704 131.955 116.742 129.227 121.66L89.8708 192.641C87.4343 197.035 87.4624 202.381 89.945 206.749L95.0883 215.8",
    stroke: "black",
    strokeWidth: 1.92852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5799 204.711L138.419 134.664",
    stroke: "black",
    strokeWidth: 1.92852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.236 200.298L145.612 147.318",
    stroke: "black",
    strokeWidth: 1.92852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.68 384.339C168.822 387.862 188.896 364.319 193.624 340.685C196.949 324.062 188.548 311.296 192.842 290.825C195.369 278.776 205.287 258.682 188.203 258.885C184.702 258.926 176.695 262.821 172.552 272.942",
    stroke: "black",
    strokeWidth: 1.92852,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.527 296.666C134.812 268.743 113.939 211.043 98.0165 219.322C89.8887 223.548 90.8681 229.892 95.5596 241.439",
    stroke: "black",
    strokeWidth: 1.92852,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.79 384.296C116.64 383.65 96.5394 359.188 89.6905 337.61C84.7371 322.004 84.9146 310.874 86.5753 283.68C87.91 261.824 80.4688 245.772 88.7411 241.57C100.894 235.397 105.865 268.48 105.865 268.48C105.865 268.48 110.213 297.332 108.819 299.929",
    stroke: "black",
    strokeWidth: 1.92852,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.623 218.333C104.463 211.721 112.803 208.611 117.341 211.365C128.619 218.206 141.065 238.759 148.099 259.774C151.873 271.05 152.032 277.206 153.963 289.654",
    stroke: "black",
    strokeWidth: 1.92852,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.024 215.078C120.352 208.591 129.021 205.168 134.97 208.553C139.414 211.082 142.855 215.415 148.067 223.135C173.021 260.1 173.136 281.735 176.998 306.631",
    stroke: "black",
    strokeWidth: 1.92852,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.977,
    cy: 285.861,
    r: 4.73547,
    transform: "rotate(-29.6097 258.977 285.861)",
    stroke: "black",
    strokeWidth: 1.92852
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346.595,
    cy: 54.6246,
    r: 4.73547,
    transform: "rotate(-29.6097 346.595 54.6246)",
    stroke: "black",
    strokeWidth: 1.92852
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.588,
    cy: 255.594,
    r: 4.73547,
    transform: "rotate(-29.6097 47.588 255.594)",
    stroke: "black",
    strokeWidth: 1.92852
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.954 164.129C242.701 154.049 234.853 146.613 226.902 144.594L223.253 142.551L217.34 145.046C207.3 149.083 203.789 164.033 210.109 179.013C216.692 194.612 230.408 201.961 240.827 197.564C241.165 197.422 247.932 194.433 247.932 194.433L246.815 191.787C251.011 184.908 251.208 174.21 246.954 164.129Z",
    fill: "url(#paint0_linear_219_50842)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.26 161.464C259.059 175.205 256.567 190.056 247.133 194.899C237.047 200.084 222.998 191.947 216.415 176.348C209.833 160.748 213.925 145.289 224.796 141.962C234.99 138.921 247.439 147.667 253.26 161.464Z",
    fill: "url(#paint1_linear_219_50842)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.119 155.542L239.77 178.165C239.691 178.926 239.249 179.599 238.571 179.989C237.894 180.38 237.057 180.443 236.304 180.162L223.765 175.471L225.534 170.849L234.936 174.366L236.955 154.913L242.119 155.542Z",
    fill: "#19AA1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.486 154.944L238.216 175.868C238.134 176.631 237.685 177.304 237.003 177.691C236.32 178.077 235.479 178.134 234.727 177.844L223.677 173.589L225.495 168.987L233.401 172.031L235.325 154.293L240.486 154.944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.984 89.3635C241.094 89.0831 223.886 102.35 213.282 123.405C203.937 141.96 209.927 151.187 214.771 150.973C224.416 150.548 224.857 133.89 236.438 123.933C248.019 113.976 259.505 115.822 270.192 123.541C282.657 132.544 307.676 163.753 282.591 176.79C262.606 187.177 248.789 181.314 241.656 189.829C235.261 197.461 248.299 213.902 293.18 209.048C340.926 203.883 343.046 186.488 346.148 177.373C350.503 164.578 343.757 145.293 337.748 131.267C327.43 107.183 301.891 69.008 275.414 63.4309C260.894 60.3731 250.555 60.8601 230.228 69.5685C217.909 74.8461 202.399 71.2988 201.563 77.5852C200.655 84.422 211.812 88.66 221.813 84.9929",
    stroke: "black",
    strokeWidth: 1.92852,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.772 77.3228C249.411 77.5042 231.879 84.2986 218.485 97.8127C205.943 110.467 200.355 129.147 208.489 138.296",
    stroke: "black",
    strokeWidth: 1.92852,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.53 69.7413C249.106 69.803 231.006 77.7049 218.865 86.9031C213.617 90.878 196.334 112.808 205.111 121.845",
    stroke: "black",
    strokeWidth: 1.92852,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_50842",
    x1: 210.2,
    y1: 179.288,
    x2: 246.822,
    y2: 163.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#195441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#195640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#197A31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#199427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#19A420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AA1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_219_50842",
    x1: 216.53,
    y1: 176.672,
    x2: 253.151,
    y2: 161.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19AA1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    stopColor: "#23CC29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23CC29"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_219_50842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 398.113,
    height: 254,
    fill: "white",
    transform: "translate(-17.2988 197.713) rotate(-29.6097)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.62582fb4743c3efd40449477049ee162.svg";
export { ForwardRef as ReactComponent };